export default function MultipleDronersPin({
  value,
  size,
}: {
  value?: number;
  size?: number;
}) {
  !size && (size = 35);
  !value && (value = 0);
  return (
    <svg version="1.1" width={size} height={size} viewBox="0 0 50 50">
      <defs></defs>
      <g transform="matrix(0.57 0 0 0.56 25.08 25.14)">
        <circle
          style={{
            stroke: "rgb(51,51,51)",
            strokeWidth: "8",
            strokeDasharray: "none",
            strokeLinecap: "butt",
            strokeDashoffset: "0",
            strokeLinejoin: "miter",
            strokeMiterlimit: "4",
            fill: "rgb(51,51,51)",
            fillRule: "nonzero",
            opacity: "1",
          }}
          cx={0}
          cy={0}
          r="40"
        />
      </g>
      <g transform="matrix(2.33 0 0 2.33 325.52 245.52)">
        <circle
          style={{
            stroke: "rgb(51,51,51)",
            strokeWidth: "8",
            strokeDasharray: "none",
            strokeLinecap: "butt",
            strokeDashoffset: "0",
            strokeLinejoin: "miter",
            strokeMiterlimit: "4",
            fill: "rgb(51,51,51)",
            fillRule: "nonzero",
            opacity: "1",
          }}
          cx="0"
          cy="0"
          r="40"
        />
      </g>
      <g transform="matrix(3.82 0 0 3.82 432.21 243.76)">
        <text
          fontFamily="'Open Sans', sans-serif"
          fontSize="18"
          fontStyle="normal"
          fontWeight="normal"
          style={{
            stroke: "rgb(236,236,236)",
            strokeOpacity: "0",
            strokeWidth: "1",
            strokeDasharray: "none",
            strokeLinecap: "butt",
            strokeDashoffset: "0",
            strokeLinejoin: "miter",
            strokeMiterlimit: "4",
            fill: "rgb(255,255,255)",
            fillRule: "nonzero",
            opacity: "1",
            whiteSpace: "pre",
          }}
        >
          <tspan
            x="-40"
            y="5.65"
            style={{
              stroke: "rgb(236,236,236)",
              strokeOpacity: "0",
              strokeWidth: "1",
              fontFamily: "'Open Sans', sans-serif",
              fontSize: "18px",
              fontStyle: "normal",
              fontWeight: "normal",
              fill: "rgb(255,255,255)",
            }}
          >
            {value}
          </tspan>
        </text>
      </g>
      <g transform="matrix(1 0 0 1 54.5 26.17)">
        <text
          fontFamily="'Open Sans', sans-serif"
          fontSize="18"
          fontStyle="normal"
          fontWeight="normal"
          style={{
            stroke: "none",
            strokeWidth: "1",
            strokeDasharray: "none",
            strokeLinecap: "butt",
            strokeDashoffset: "0",
            strokeLinejoin: "miter",
            strokeMiterlimit: "4",
            fill: "rgb(255,255,255)",
            fillRule: "nonzero",
            opacity: "1",
            whiteSpace: "pre",
          }}
        >
          <tspan
            x={-size}
            y="5.65"
            style={{
              strokeWidth: "1",
              fontFamily: "'Open Sans' sansSerif",
              fontSize: "18px",
              fontStyle: "normal",
              fontWeight: "normal",
            }}
          >
            {value}
          </tspan>
        </text>
      </g>
    </svg>
  );
}
